<template>
  <div class="dashboard">
    <div class="dashboard-container">
      <!-- 欢迎信息 -->
      <div class="welcome-card">
        <div class="welcome-content">
          <div class="welcome-text">
            <h2>欢迎回来，{{ adminInfo.nickName }}！</h2>
            <p>今天是 {{ currentDate }}，祝您工作愉快！</p>
          </div>
          <div class="welcome-avatar">
            <img :src="avatar" alt="头像" />
          </div>
        </div>
      </div>

      <!-- 统计卡片 -->
      <!-- <div class="stats-grid">
        <div class="stats-card">
          <div class="stats-icon user-icon">
            <i class="el-icon-user"></i>
          </div>
          <div class="stats-info">
            <div class="stats-number">{{ stats.userCount }}</div>
            <div class="stats-label">管理用户</div>
          </div>
        </div>

        <div class="stats-card">
          <div class="stats-icon group-icon">
            <i class="el-icon-s-custom"></i>
          </div>
          <div class="stats-info">
            <div class="stats-number">{{ stats.groupCount }}</div>
            <div class="stats-label">管理群组</div>
          </div>
        </div>

        <div class="stats-card">
          <div class="stats-icon message-icon">
            <i class="el-icon-chat-line-round"></i>
          </div>
          <div class="stats-info">
            <div class="stats-number">{{ stats.messageCount }}</div>
            <div class="stats-label">今日消息</div>
          </div>
        </div>

        <div class="stats-card">
          <div class="stats-icon online-icon">
            <i class="el-icon-connection"></i>
          </div>
          <div class="stats-info">
            <div class="stats-number">{{ stats.onlineCount }}</div>
            <div class="stats-label">在线用户</div>
          </div>
        </div>
      </div> -->

      <!-- 图表区域 -->
      <!-- <div class="charts-grid">
        <div class="chart-card">
          <div class="card-header">
            <h3>用户增长趋势</h3>
          </div>
          <div class="chart-content">
            <div id="userChart" style="height: 300px"></div>
          </div>
        </div>

        <div class="chart-card">
          <div class="card-header">
            <h3>消息统计</h3>
          </div>
          <div class="chart-content">
            <div id="messageChart" style="height: 300px"></div>
          </div>
        </div>
      </div> -->

      <!-- 快捷操作 -->
      <!-- <div class="quick-actions">
        <div class="actions-card">
          <div class="card-header">
            <h3>快捷操作</h3>
          </div>
          <div class="actions-grid">
            <div class="action-item" @click="$router.push('/admin/list')">
              <i class="el-icon-user-solid"></i>
              <span>管理员管理</span>
            </div>
            <div class="action-item" @click="$router.push('/user/list')">
              <i class="el-icon-user"></i>
              <span>用户管理</span>
            </div>
            <div class="action-item" @click="$router.push('/group/list')">
              <i class="el-icon-s-custom"></i>
              <span>群组管理</span>
            </div>
            <div class="action-item">
              <i class="el-icon-setting"></i>
              <span>系统设置</span>
            </div>
          </div>
        </div>
      </div> -->

      <!-- 最近活动 -->
      <!-- <div class="recent-activities">
        <div class="activities-card">
          <div class="card-header">
            <h3>最近活动</h3>
          </div>
          <div class="activities-list">
            <div
              v-for="activity in recentActivities"
              :key="activity.id"
              class="activity-item"
            >
              <div class="activity-time">{{ formatTime(activity.time) }}</div>
              <div class="activity-content">{{ activity.content }}</div>
            </div>
          </div>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "Dashboard",
  data() {
    return {
      stats: {
        userCount: 0,
        groupCount: 0,
        messageCount: 0,
        onlineCount: 0,
      },
      recentActivities: [],
    };
  },
  computed: {
    ...mapGetters(["adminInfo"]),
    currentDate() {
      const now = new Date();
      return now.toLocaleDateString("zh-CN", {
        year: "numeric",
        month: "long",
        day: "numeric",
        weekday: "long",
      });
    },
    avatar() {
      return (
        this.adminInfo.headImage ||
        "https://wpimg.wallstcn.com/f778738c-e4f8-4870-b634-56703b4acafe.gif"
      );
    },
  },
  mounted() {
    this.loadDashboardData();
    this.initCharts();
  },
  methods: {
    loadDashboardData() {
      // 模拟数据，实际项目中应该从API获取
      this.stats = {
        userCount: 0,
        groupCount: 0,
        messageCount: 0,
        onlineCount: 0,
      };

      this.recentActivities = [
        {
          id: 1,
          time: new Date(Date.now() - 5 * 60 * 1000),
          content: "用户张三注册了账号",
        },
        {
          id: 2,
          time: new Date(Date.now() - 15 * 60 * 1000),
          content: '群组"技术交流群"被创建',
        },
        {
          id: 3,
          time: new Date(Date.now() - 30 * 60 * 1000),
          content: "管理员李四登录了系统",
        },
        {
          id: 4,
          time: new Date(Date.now() - 60 * 60 * 1000),
          content: "用户王五发送了消息",
        },
      ];
    },
    initCharts() {
      // 这里可以初始化图表，使用 ECharts 或其他图表库
      // 由于项目中已经引入了 ECharts，可以在这里实现图表
      console.log("初始化图表");
    },
    formatTime(time) {
      const now = new Date();
      const diff = now - time;

      if (diff < 60 * 1000) {
        return "刚刚";
      } else if (diff < 60 * 60 * 1000) {
        return Math.floor(diff / (60 * 1000)) + "分钟前";
      } else if (diff < 24 * 60 * 60 * 1000) {
        return Math.floor(diff / (60 * 60 * 1000)) + "小时前";
      } else {
        return time.toLocaleDateString();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.dashboard {
  padding: 20px;

  .dashboard-container {
    max-width: 1200px;
    margin: 0 auto;
  }

  .welcome-card {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    border-radius: 8px;
    padding: 30px;
    margin-bottom: 20px;
    color: white;

    .welcome-content {
      display: flex;
      justify-content: space-between;
      align-items: center;

      .welcome-text {
        h2 {
          margin: 0 0 10px 0;
          font-size: 24px;
          font-weight: 500;
        }

        p {
          margin: 0;
          font-size: 14px;
          opacity: 0.9;
        }
      }

      .welcome-avatar {
        img {
          width: 60px;
          height: 60px;
          border-radius: 50%;
          border: 3px solid rgba(255, 255, 255, 0.3);
        }
      }
    }
  }

  .stats-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 20px;
    margin-bottom: 20px;

    .stats-card {
      background: white;
      border-radius: 8px;
      padding: 24px;
      display: flex;
      align-items: center;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
      transition: transform 0.3s;

      &:hover {
        transform: translateY(-2px);
      }

      .stats-icon {
        width: 60px;
        height: 60px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 16px;

        i {
          font-size: 24px;
          color: white;
        }

        &.user-icon {
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
        }

        &.group-icon {
          background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
        }

        &.message-icon {
          background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);
        }

        &.online-icon {
          background: linear-gradient(135deg, #43e97b 0%, #38f9d7 100%);
        }
      }

      .stats-info {
        .stats-number {
          font-size: 28px;
          font-weight: 600;
          color: #303133;
          line-height: 1;
        }

        .stats-label {
          font-size: 14px;
          color: #909399;
          margin-top: 4px;
        }
      }
    }
  }

  .charts-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 20px;
    margin-bottom: 20px;

    .chart-card {
      background: white;
      border-radius: 8px;
      padding: 20px;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);

      .card-header {
        h3 {
          margin: 0 0 20px 0;
          font-size: 16px;
          color: #303133;
        }
      }
    }
  }

  .quick-actions {
    margin-bottom: 20px;

    .actions-card {
      background: white;
      border-radius: 8px;
      padding: 20px;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);

      .card-header {
        h3 {
          margin: 0 0 20px 0;
          font-size: 16px;
          color: #303133;
        }
      }

      .actions-grid {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
        gap: 20px;

        .action-item {
          display: flex;
          flex-direction: column;
          align-items: center;
          padding: 20px;
          border-radius: 8px;
          background: #f8f9fa;
          cursor: pointer;
          transition: all 0.3s;

          &:hover {
            background: #e9ecef;
            transform: translateY(-2px);
          }

          i {
            font-size: 24px;
            color: #409eff;
            margin-bottom: 8px;
          }

          span {
            font-size: 14px;
            color: #606266;
          }
        }
      }
    }
  }

  .recent-activities {
    .activities-card {
      background: white;
      border-radius: 8px;
      padding: 20px;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);

      .card-header {
        h3 {
          margin: 0 0 20px 0;
          font-size: 16px;
          color: #303133;
        }
      }

      .activities-list {
        .activity-item {
          display: flex;
          padding: 12px 0;
          border-bottom: 1px solid #f0f0f0;

          &:last-child {
            border-bottom: none;
          }

          .activity-time {
            width: 80px;
            font-size: 12px;
            color: #909399;
            flex-shrink: 0;
          }

          .activity-content {
            flex: 1;
            font-size: 14px;
            color: #606266;
          }
        }
      }
    }
  }
}

@media (max-width: 768px) {
  .dashboard {
    padding: 10px;

    .stats-grid {
      grid-template-columns: 1fr;
    }

    .charts-grid {
      grid-template-columns: 1fr;
    }

    .welcome-card .welcome-content {
      flex-direction: column;
      text-align: center;

      .welcome-avatar {
        margin-top: 20px;
      }
    }
  }
}
</style>
